import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';
import { MediaManagerSDKAnyItem } from '../../media-manager-sdk';
import { extractCommonBiFieldsFromItems } from '../../bi';
import { useFileType } from './useFileType';
import { mediaManagerTagsActions } from '@wix/bi-logger-media-manager-g6/v2';

export enum TagsActionsTargets {
  Added = 'added',
  Deleted = 'deleted',
  Clicked = 'click',
}

export enum TagsActionsClickOrigins {
  AddMedia = 'add_media',
  MoreInfo = 'more_info',
}

export interface Params {
  clickOrigin: TagsActionsClickOrigins;
  tag: string;
  target: TagsActionsTargets;
}

export const useTrackTagsActions = () => {
  const fileType = useFileType();

  return useMemo(
    () => ({
      trackTagsActions: (params: Params, items: MediaManagerSDKAnyItem | MediaManagerSDKAnyItem[]) => {
        bi.logger().report(
          mediaManagerTagsActions({ ...extractCommonBiFieldsFromItems(items, { fileType }), ...params }),
        );
      },
    }),
    [fileType],
  );
};
